import React from "react";
import PropTypes from "prop-types";
import styles from "./styles";
import Typography from "@material-ui/core/Typography";
import rectangleImge from "../../assets/images/rectangle.png";
import ReactHtmlParser from "react-html-parser";
import { Grid, Hidden } from "@material-ui/core";

export const PlanItemRow = ({
  longerCoverages,
  selectedOnePlanCoverages,
  selectedSecondPlanCoverages,
  selectedThirdPlanCoverages,
  selectedOnePlanError,
  selectedSecondPlanError,
  selectedThirdPlanError
}) => {
  const classes = styles();

  let banderaErrors1 = false;
  let banderaErrors2 = false;
  let banderaErrors3 = false;

  const templateConverage = (
    coveragePlan,
    index,
    validDrawRow,
    numberSelect
  ) => {
    console.log("index:", index, coveragePlan, validDrawRow);
    if (validDrawRow && numberSelect == 3) {
      if (banderaErrors3) {
        return (
          <div
            className={classes.mainContainer}
            key={coveragePlan?.type?.id || 0}
          >
            <Typography
              component="p"
              className={classes.titleStyle}
            ></Typography>
          </div>
        );
      }
      banderaErrors3 = true;
      return (
        <div
          className={classes.mainContainer}
          key={coveragePlan?.type?.id || 0}
        >
          <Typography component="p" className={classes.titleStyle}>
            {validDrawRow}
          </Typography>
        </div>
      );
    }

    if (validDrawRow && numberSelect == 2) {
      if (banderaErrors2) {
        return (
          <div
            className={classes.mainContainer}
            key={coveragePlan?.type?.id || 0}
          >
            <Typography
              component="p"
              className={classes.titleStyle}
            ></Typography>
          </div>
        );
      }
      banderaErrors2 = true;
      return (
        <div
          className={classes.mainContainer}
          key={coveragePlan?.type?.id || 0}
        >
          <Typography component="p" className={classes.titleStyle}>
            {validDrawRow}
          </Typography>
        </div>
      );
    }

    if (validDrawRow && numberSelect == 1) {
      if (banderaErrors1) {
        return (
          <div
            className={classes.mainContainer}
            key={coveragePlan?.type?.id || 0}
          >
            <Typography
              component="p"
              className={classes.titleStyle}
            ></Typography>
          </div>
        );
      }
      banderaErrors1 = true;
      return (
        <div
          className={classes.mainContainer}
          key={coveragePlan?.type?.id || 0}
        >
          <Typography component="p" className={classes.titleStyle}>
            {validDrawRow}
          </Typography>
        </div>
      );
    }

    return coveragePlan?.data ? (
      <div className={classes.mainContainer} key={coveragePlan.data.id}>
        {coveragePlan?.data?.images?.length > 0 ? (
          <img
            src={coveragePlan.data.images[0].url}
            alt={coveragePlan.data.name}
            className={classes.imageStyle}
          ></img>
        ) : (
          ""
        )}
        {index === 0 ? (
          <>
            <Typography component="p" className={classes.titleStyle}>
              {coveragePlan?.data?.name}
            </Typography>
            <Typography component="div" className={classes.descriptionStyle}>
              {ReactHtmlParser(coveragePlan?.data?.description)}
            </Typography>
          </>
        ) : (
          <>
            <Typography component="p" className={classes.titleStyleSub}>
              {coveragePlan?.data?.name}
            </Typography>
            <Typography component="div" className={classes.descriptionStyleSub}>
              {ReactHtmlParser(coveragePlan?.data?.description)}
            </Typography>
          </>
        )}
      </div>
    ) : (
      <div className={classes.mainContainer} key={coveragePlan?.type?.id || 0}>
        <img src={rectangleImge} alt="Imagen de nada" />
      </div>
    );
  };
  console.log(longerCoverages, "longerCoverages");
  return (
    <>
      {longerCoverages &&
        longerCoverages.map((coverage, index) => {
          const coveragePlanOne = selectedOnePlanCoverages[index];
          const coveragePlanSecond = selectedSecondPlanCoverages[index];
          const coveragePlanThird = selectedThirdPlanCoverages[index];
          return (
            <Grid
              key={index}
              container
              justify="center"
              className={classes.planDescriptionContainer}
            >
              <Grid item className={classes.columnContainer}>
                {templateConverage(
                  coveragePlanOne,
                  index,
                  selectedOnePlanError,
                  1
                )}
              </Grid>
              <Grid item className={classes.columnContainer}>
                {templateConverage(
                  coveragePlanSecond,
                  index,
                  selectedSecondPlanError,
                  2
                )}
              </Grid>
              <Hidden xsDown>
                <Grid item className={classes.columnContainer}>
                  {templateConverage(
                    coveragePlanThird,
                    index,
                    selectedThirdPlanError,
                    3
                  )}
                </Grid>
              </Hidden>
            </Grid>
          );
        })}
    </>
  );
};
PlanItemRow.propTypes = {
  longerCoverages: PropTypes.any,
  selectedOnePlanCoverages: PropTypes.any,
  selectedSecondPlanCoverages: PropTypes.any,
  selectedThirdPlanCoverages: PropTypes.any,
  selectedOnePlanError: PropTypes.any,
  selectedSecondPlanError: PropTypes.any,
  selectedThirdPlanError: PropTypes.any
};
